import MultiStreamRecorder from 'recordrtc';
import { injectMetadata } from '@/utils/video';
import logger from '@/modules/Logger';

export default {
  namespaced: true,
  state: {
    isRecording: false,
    recorder: null,
    blob: null,
    displayStream: null,
    recordingTime: 0,
    interval: null,
  },

  mutations: {
    setRecording(state, payload) {
      state.isRecording = payload
    },
    setRecorder(state, payload) {
      state.recorder = payload
    },
    setBlob(state, payload) {
      state.blob = payload
    },
    setDisplayStream(state, payload) {
      state.displayStream = payload
    },
    setRecordingTime(state, payload) {
      state.recordingTime = payload
    },
    setTimeInterval(state, payload) {
      state.interval = payload
    }
  },

  actions: {
    initRecorder({ state, commit }, streams) {
      let multiStreamRecorder = new MultiStreamRecorder(streams, {
        elementClass: 'multi-streams-mixer',
        mimeType: 'video/webm;codecs=vp9',
        frameInterval: 60,
        video: {
          height: window.screen.height * window.devicePixelRatio,
          width: window.screen.width * window.devicePixelRatio
        }
      });

      multiStreamRecorder.ondataavailable = function (blob) {
        commit('setBlob', blob)
      };

      logger.info('Recording Started.', { operation: 'recorder', rec_status: 'used' });
      multiStreamRecorder.startRecording();    

      commit('setRecorder', multiStreamRecorder);  

      let interval = setInterval(function () {
        commit('setRecordingTime', state.recordingTime + 1)
      }, 1000);

      commit('setTimeInterval', interval);
    },

    addStreams({ state }, streams) {
      state.recorder.getInternalRecorder().addStreams(streams)
    },
    updateAudioStreams({ state }, audioStreams) {
      const mixer = state.recorder.getInternalRecorder().getMixer();
      if (!mixer || !mixer.audioContext || !mixer.audioDestination) {
        return;
      }

      if (mixer.audioSources && mixer.audioSources.length) {
        mixer.audioSources.forEach(function(source) {
          source.disconnect();
        });
        mixer.audioSources = [];
      }

      audioStreams.forEach(function(stream) {
        if (!stream.getAudioTracks().length) {
          return;
        }
        var audioSource = mixer.audioContext.createMediaStreamSource(stream);
        audioSource.connect(mixer.audioDestination);
        mixer.audioSources.push(audioSource);
      });

      logger.info('Recording audio streams updated.', { operation: 'recorder', rec_status: 'audio_updated' });
    },   
    stopRecorder({ state, commit }) {
      if (state.recorder != null) {
        state.recorder.stopRecording(async function () {
          let url = null;
          try {
            const rawBlob = state.recorder.getBlob();
            const seekableBlob = await injectMetadata(rawBlob);
            url = window.URL.createObjectURL(seekableBlob);
            const link = document.createElement("a");
            document.body.appendChild(link);
            link.style = "display: none";
            link.href = url;
            link.download = 'video.webm';
            link.click();
            document.body.removeChild(link);
          } catch (error) {
            logger.error('Failed to download recording.', {
              operation: 'recorder',
              rec_status: 'error',
              error: error && error.message ? error.message : String(error)
            });
          } finally {
            if (url) {
              window.URL.revokeObjectURL(url);
            }
            commit('setRecorder', null);
          }
        });  
        commit('setRecording', false);   
        clearInterval(state.interval);
        commit('setRecordingTime', 0)    
        state.displayStream.getTracks().forEach(track => {
          track.stop();
        });

        logger.info('Recording Stopped.', { operation: 'recorder' });
      }
    },   
    resetRecorder({ state }, streams) {
      state.recorder.getInternalRecorder().resetVideoStreams(streams);
      logger.info('resetting recorder is successful.', { operation: 'recorder' });
    }
  }
}
